'use client'

import React from 'react'

import { Box, HTMLChakraProps, Text } from '@chakra-ui/react'

import type { ColorScheme } from '../../types'
import { WorkflowCheckIcon } from '../Icon'
import {
  successBannerIconStyles,
  successBannerLabelStyles,
  successBannerStyles,
} from './SuccessBanner.styles'

export type SuccessBannerProps = HTMLChakraProps<'div'> & {
  colorScheme?: ColorScheme
  label?: string
}

export const SuccessBanner = ({
  colorScheme = 'dark',
  label,
  ...rest
}: SuccessBannerProps) => (
  <Box {...successBannerStyles(colorScheme)} {...rest}>
    <Box aria-hidden='true' {...successBannerIconStyles}>
      <WorkflowCheckIcon />
    </Box>
    {label && <Text {...successBannerLabelStyles}>{label}</Text>}
  </Box>
)
